import axios from 'axios';

import { db } from '../utils/configureFirebase';

export const getGDGroupDetail = (id, cb) => {
  const docRef = db.collection('gdGroups').doc(id);

  docRef
    .get()
    .then((doc) => {
      if (doc.exists) {
        cb(doc.data());
      } else {
        cb(null);
      }
    })
    .catch((error) => {
      console.error(error); // eslint-disable-line no-console
    });
};

export const markGDCompleted = async (id, onSuccess, onError) => {
  try {
    const {
      data: { data },
    } = await axios.post(
      'https://us-central1-jyp-admin-saas.cloudfunctions.net/groupDiscussion/markComplete',
      { id },
    );
    onSuccess(data);
  } catch (error) {
    onError(error);
  }
};

export const getCandidateGDFormConfig = async (id, onSuccess, onError) => {
  try {
    const {
      data: { data },
    } = await axios.options(
      `https://us-central1-jyp-admin-saas.cloudfunctions.net/updateCandidate/${id}/?stage=groupDiscussion`,
    );
    onSuccess(data);
  } catch (error) {
    onError(error);
  }
};

export const updateCandidateGDInfo = async (id, updateData, onSuccess, onError) => {
  try {
    const {
      data: { data },
    } = await axios.put(
      `https://us-central1-jyp-admin-saas.cloudfunctions.net/updateCandidate/${id}/?stage=groupDiscussion`,
      updateData,
    );
    onSuccess(data);
  } catch (error) {
    onError(error);
  }
};



// WEBPACK FOOTER //
// ./src/services/groupDiscussionDetailServices.js